// extracted by mini-css-extract-plugin
module.exports = {"Title":"Title___22i7C","ButtonsWrap":"ButtonsWrap___-nzSE","ButtonContent":"ButtonContent___zlAiC","ButtonText":"ButtonText___3EV76","loading":"loading___1JYAa"};